import React from 'react';
import ReactDOM from 'react-dom';
import Image from './Image.jsx';
import AutoplayingVideo from './AutoplayingVideo.jsx';
import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';

class Title extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'Title';


    // initial state object
    this.state = {
      inView: false,
      scrolledPast: false,
    };


    // bind functions to component
    this.renderCollectionTitle = this.renderCollectionTitle.bind(this);
    this.renderAuthor = this.renderAuthor.bind(this);
    this.renderCredit = this.renderCredit.bind(this);
    this.renderSubhead = this.renderSubhead.bind(this);
    this.renderPublishedOn = this.renderPublishedOn.bind(this);
    this.renderAdTile = this.renderAdTile.bind(this);
    this.renderImage = this.renderImage.bind(this);
    this.renderFullBleedBgImage = this.renderFullBleedBgImage.bind(this);
  }


  /**
   * Called after component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    this.node = ReactDOM.findDOMNode(this);
  }


  /**
   * Called when component updates
   * @returns {undefined} undefined
   */
  componentDidUpdate() {
    if (typeof window !== 'undefined') {
      const bounds = this.node.getBoundingClientRect();

      if (bounds.top <= 80 && bounds.bottom >= 80) {
        if (this.state.scrolledPast) {
          this.setState({ scrolledPast: false }, () => {
            AppDispatcher.handleViewAction({
              actionType: AppConstants.SCROLLED_PAST_TITLE,
              scrolledPastTitle: false,
            });
          });
        }

        if (this.props.originalUiColor === 'light' && !this.state.inView) {
          this.setState({ inView: true }, () => {
            AppDispatcher.handleViewAction({
              actionType: AppConstants.UI_COLOR_CHANGE,
              uiColor: 'light',
            });
          });
        }
      } else {
        if (!this.state.scrolledPast) {
          this.setState({ scrolledPast: true }, () => {
            AppDispatcher.handleViewAction({
              actionType: AppConstants.SCROLLED_PAST_TITLE,
              scrolledPastTitle: true,
            });
          });
        }

        if (this.state.inView) {
          this.setState({ inView: false }, () => {
            AppDispatcher.handleViewAction({
              actionType: AppConstants.UI_COLOR_CHANGE,
              uiColor: 'dark',
            });
          });
        }
      }
    }
  }


  /**
   * Renders collection title
   * @returns {ReactElement} React element
   */
  renderCollectionTitle() {
    const data = this.props.data;
    let element;

    if (data.title.collection_title.length > 0) {
      element = (
        <div
          className='collection-title'
          dangerouslySetInnerHTML={{ __html: data.title.collection_title }}
        />
      );
    }

    return element;
  }


  /**
   * Renders author div
   * @returns {ReactElement} React element
   */
  renderAuthor() {
    const data = this.props.data;
    let element;

    if (data.title.author.length > 0) {
      element = (
        <h3
          className='author'
          dangerouslySetInnerHTML={{ __html: data.title.author }}
        />
      );
    }

    return element;
  }


  /**
   * Renders credit div
   * @returns {ReactElement} React element
   */
  renderCredit() {
    const data = this.props.data;
    let element;

    if (data.credit.length > 0) {
      element = (
        <h3
          className='credit'
          dangerouslySetInnerHTML={{ __html: data.credit }}
        />
      );
    }

    return element;
  }


  /**
   * Renders subhead div
   * @returns {ReactElement} React element
   */
  renderSubhead() {
    const data = this.props.data;
    let element;

    if (data.title.subhead.length > 0) {
      element = (
        <h3
          className='subhead'
          dangerouslySetInnerHTML={{ __html: data.title.subhead }}
        />
      );
    }

    return element;
  }


  /**
   * Renders publish data
   * @returns {ReactElement} React element
   */
  renderPublishedOn() {
    const data = this.props.data;
    let element;

    if (data.title.published_on.length > 0) {
      element = (
        <h4 className='publish-date'>{data.title.published_on}</h4>
      );
    }

    return element;
  }


  /**
   * Renders ad title
   * @returns {ReactElement} React element
   */
  renderAdTile() {
    const data = this.props.data;
    let element;

    if (data.small_ad_image_url) {
      const adTitle = data.ad_title ?
        (<div className='ad-title'>{data.ad_title}</div>) :
        null;
      element = (
        <div className='ad-tle'>
          {adTitle}
          <img
            className='trckpxl'
            src={data.tracking_pixel_url} alt=''
          />
          <a href={data.clickthrough_url}>
            <img src={data.small_ad_image_url} alt='' />
          </a>
        </div>
      );
    }

    return element;
  }


  /**
   * Renders image
   * @returns {ReactElement} React element
   */
  renderImage() {
    const data = this.props.data;
    let element;

    if (data.title.headline_position === 'above-image' &&
      data.landscape_images.smallest.url) {
      const imageData = {
        landscape: data.landscape_images,
        portrait: data.portrait_images,
      };

      if (!data.video_url.length) {
        element = (
          <div className='image'>
            <Image data={imageData} />
          </div>
        );
      } else {
        element = (
          <AutoplayingVideo
            elementId={'autoplaying-video-' + data.id}
            fullBleed
            id={data.id}
            iteration={0}
            loop
            posterImageUrl={data.landscape_images.large.url}
            scrollPadding={200}
            scrollTop={this.props.scrollTop}
            touch={this.props.touch}
            videoUrl={data.video_url}
            videoWidth={1600}
            videoHeight={900}
            windowSize={this.props.windowSize}
          />
        );
      }
    }

    return element;
  }


  /**
   * Renders full bleed background image
   * @returns {ReactElement} React element
   */
  renderFullBleedBgImage() {
    const data = this.props.data;
    let element;

    if (data.title.headline_position !== 'above-image') {
      if (!data.video_url.length) {
        const imageData = {
          landscape: data.landscape_images,
          portrait: data.portrait_images,
        };

        element = (
          <div className='bg-image'>
            <Image
              data={imageData}
              fullBleed
              windowSize={this.props.windowSize}
            />
          </div>
        );
      } else {
        element = (
          <AutoplayingVideo
            elementId={'autoplaying-video-' + data.id}
            fullBleed
            id={data.id}
            iteration={0}
            loop
            posterImageUrl={data.landscape_images.large.url}
            scrollPadding={200}
            scrollTop={this.props.scrollTop}
            touch={this.props.touch}
            videoUrl={data.video_url}
            videoWidth={1600}
            videoHeight={900}
            windowSize={this.props.windowSize}
          />
        );
      }
    }

    return element;
  }


  /**
   * Renders component
   * @returns {ReactElement} React element
   */
  render() {
    const collectionTitle = this.renderCollectionTitle();
    const author = this.renderAuthor();
    const credit = this.renderCredit();
    const subhead = this.renderSubhead();
    const publishedOn = this.renderPublishedOn();
    const adTile = this.renderAdTile();
    const image = this.renderImage();
    const fullBleedBgImage = this.renderFullBleedBgImage();
    const data = this.props.data;
    const className = 'component-title section-' +
      this.props.iteration + '-' + data.id + ' ' +
      data.title.headline_position;

    return (
      <section className={className}>
        {fullBleedBgImage}
        <div className='bg-shape' />
        <div className='content'>
          {collectionTitle}
          <h1 className='headline'>{data.title.headline}</h1>
          {subhead}
          {author}
          {credit}
          {publishedOn}
          {adTile}
        </div>
        {image}
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - The section data
 * @prop {Number} iteration - The iteration of the element
 * @prop {String} originalUiColor - The original UI Color of the story
 * @prop {Number} scrollTop - The amount, in pixels, the user has scrolled in
 * the entire article
 * @prop {Number} touch - If the browser supports touch events
 * @prop {Object} windowSize - An object holding the width
 * and size of the window
 */
Title.propTypes = {
  data: React.PropTypes.object,
  iteration: React.PropTypes.number,
  originalUiColor: React.PropTypes.string,
  scrollTop: React.PropTypes.number,
  touch: React.PropTypes.bool,
  windowSize: React.PropTypes.object,
};


export default Title;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/Title.jsx
 **/